import { cn } from "@/lib/chillnn/cn";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/input/select";

import { FormErrorMessage, FormItem, FormLabel } from "../../_base/form";

import type { FormOptionType } from "../../_types/type";
import type { ReactNode } from "react";

type SelectFieldProps<T> = {
	value: T;
	placeholder?: string;
	options: FormOptionType[];
	onValueChange: (value: string) => void;
	disabled?: boolean;

	errorMessage?: string;
	label?: ReactNode;

	className?: string;
};

export const SelectFieldNew = <T,>({
	value,
	placeholder,
	options,
	onValueChange,
	disabled = false,
	errorMessage,
	label,
	className,
}: SelectFieldProps<T>): JSX.Element | null => {
	return (
		<FormItem>
			<FormLabel>{label}</FormLabel>

			<div className="relative">
				<Select onValueChange={onValueChange} value={String(value)}>
					<div className={cn("w-full min-w-[110px]", className)}>
						<SelectTrigger disabled={disabled}>
							<SelectValue placeholder={placeholder} />
						</SelectTrigger>
					</div>
					<SelectContent>
						{options.map((item) => {
							if (!String(item.value)) return null;

							return (
								<SelectItem value={String(item.value)} key={item.id}>
									{String(item.label)}
								</SelectItem>
							);
						})}
					</SelectContent>
				</Select>
				<FormErrorMessage>{errorMessage}</FormErrorMessage>
			</div>
		</FormItem>
	);
};
